import { render, staticRenderFns } from "./SDCardBtn.vue?vue&type=template&id=5349280e"
import script from "./SDCardBtn.vue?vue&type=script&lang=ts"
export * from "./SDCardBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports